import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="chat-search"
export default class extends Controller {
  static targets = ["form", "searchType", "input"]

  switchTab(event) {
    const searchType = event.params.type
    this.searchTypeTarget.value = searchType

    // Update placeholder
    this.inputTarget.placeholder = `Search ${searchType === 'staff' ? 'staff' : 'guardians'}...`

    // Clear and refocus input
    this.inputTarget.value = ""
    this.inputTarget.focus()

    // Update tab styling
    const buttons = this.element.querySelectorAll('button[data-action*="switchTab"]')
    buttons.forEach(btn => {
      const isActive = btn.dataset.chatSearchTypeParam === searchType
      if (isActive) {
        btn.style.borderColor = '#0d9488'
        btn.style.color = '#0d9488'
        btn.style.background = 'rgba(20, 184, 166, 0.05)'
      } else {
        btn.style.borderColor = 'transparent'
        btn.style.color = 'var(--chat-text-secondary)'
        btn.style.background = 'transparent'
      }
    })

    // Submit the form to load the initial list for the new tab
    this.formTarget.requestSubmit()
  }
}
